
import React from "react";
import CtaButton from "./CtaButton";
import { assetUrl } from "@/config/assets";
import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";

const HeroSection = () => {
  return (
    <section className="bg-elfGreen-light py-16 md:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 text-foreground leading-tight">
              Free Elf Letter Generator — Create Magical Letters in Minutes
            </h1>
            <p className="text-lg md:text-xl mb-4 text-foreground/90 max-w-lg">
              Create a personalized elf letter, then receive a printable PDF by email. Includes 3 free PDF deliveries per email address.
            </p>
            <p className="text-sm md:text-base mb-8 text-foreground/80">
              Free Christmas resources here. Unlimited letters and premium templates with a Family membership at The Magic Letter Box.
            </p>
            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4">
              <CtaButton 
                text="Try Free Letter Generator" 
                href="/elf-letter-generator?utm_source=home&utm_medium=hero&utm_campaign=free-generator" 
                variant="primary"
              />
              <MagicLetterBoxLink source="home-hero">Explore Family Membership</MagicLetterBoxLink>
              <CtaButton 
                text="Explore Blog" 
                href="/blog/" 
                variant="secondary"
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={assetUrl("homepage-media/Joyful-Elves-in-Mailroom.webp")}
              alt="Joyful Elves in Mailroom"
              title="Joyful Elves in Mailroom"
              width="600"
              height="400"
              loading="eager"
              fetchPriority="high"
              className="rounded-2xl shadow-lg max-w-full h-auto animate-float"
            />
          </div>
        </div>
      </div>
      <div className="hero-wave">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
